import type { CustomPageDataO } from "@scripts/generated/models/customPages";
import { SitesJumpLink } from "@scripts/react/components/SidebarLinks";

export const customPage = (p: CustomPageDataO): SitesJumpLink =>
  SitesJumpLink(p.title, [], { overrideAnchor: `custom-page-${p.page.index}` });
